/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import BaseControl from 'scripts/base-control';
import DomEventsManager from 'scripts/dom-events-manager';
import appContext from 'scripts/app-context';

const isScrollNowClass = 'is-scroll-now';
const debounceClearScrollStatusTime = 300;

export default BaseControl.extend({
    init: function () {
        this._super();
        DomEventsManager.subscribe(this);
        appContext.model.bind('page-scroll-toggle', this.pageScrollToggle.bind(this));
    },

    onWindowScroll: function () {
        this.$element.addClass(isScrollNowClass);
        this.debouncedClearScrollStatus();
    },

    debouncedClearScrollStatus: _.debounce(function () {
        this.$element.removeClass(isScrollNowClass);
    }, debounceClearScrollStatusTime),

    pageScrollToggle: function (ev, flag) {
        if (flag) {
            this.pageScroll = can.$('html').scrollTop();
        }

        this.$element.toggleClass('scroll-disabled', flag);
        if (flag) {
            can.$('html').find('.main-wrapper').scrollTop(this.pageScroll);
        }
        else {
            can.$('html').scrollTop(this.pageScroll);
        }
    }
});